function formatParis(iso: string): string {
  try {
    return new Date(iso).toLocaleString('fr-FR', {
      timeZone: 'Europe/Paris',
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

/** Rempli au build Vite (`vite.config.ts` → `define`). */
export const ADMIN_UI_BUILD = {
  version: __ADMIN_UI_VERSION__,
  buildAtIso: __ADMIN_UI_BUILD_AT__,
  get builtAtParisLabel(): string {
    return formatParis(this.buildAtIso);
  },
} as const;
